import React from 'react';
import { Link } from 'react-router-dom';

const BackLink = () => {
  return (
    <Link className="back-link" to='/'><i className="fas fa-chevron-left"></i>Back</Link>
  );
};

export default BackLink;



// WEBPACK FOOTER //
// ./src/components/BackLink.js